module.exports = __webpack_public_path__ + "files/af47e8347b0cf0c7f508390e8dc6c888.png";


//////////////////
// WEBPACK FOOTER
// ./images/selogo-full.png
// module id = 801
// module chunks = 0